var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.673 6.155a.328.328 0 01.09-.17L8.934.818a1.276 1.276 0 011.804 1.806L5.57 7.791a.327.327 0 01-.17.091l-1.667.333a.333.333 0 01-.393-.393l.333-1.667zm12.034-1.641A1 1 0 0116 5.22v7.333a1 1 0 01-1 1H1a1 1 0 01-1-1V5.221a1 1 0 011-1h2.712a.167.167 0 01.118.284l-.773.773a1.333 1.333 0 00-.364.68l-.334 1.667a1.333 1.333 0 001.308 1.596c.65-.074 1.295-.194 1.928-.36.258-.051.495-.178.681-.364l4.227-4.228a.166.166 0 01.118-.048H15a1 1 0 01.707.293zm-2.04 5.873H8.333a.5.5 0 000 1h5.334a.5.5 0 100-1z",
    fill: "#8C92A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5e99ed4bda7deb374900593741c35049.svg";
export { ForwardRef as ReactComponent };